import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-edit-combustible-formula',
  templateUrl: './dialog-edit-combustible-formula.component.html',
  styleUrls: ['./dialog-edit-combustible-formula.component.scss']
})
export class DialogEditCombustibleFormulaComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEditCombustibleFormulaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
